import { PropsWithChildren } from 'react';

export type ToolbarContainerProps = PropsWithChildren<{}>;

export const ToolbarContainer = ({ children }: ToolbarContainerProps) => {
  return (
    <div className="flex flex-wrap border-solid border-neutral-300 border-b-[1px] bg-neutral-100 rounded-t-md overflow-x-auto">
      {children}
    </div>
  );
};
